<div #modalRoot class="modal fade rtl" [id]="modalId" tabindex="-1" [attr.aria-labelledby]="modalId + '-title'" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-header">
        <div>
          <h5 class="modal-title" [id]="modalId + '-title'">{{ title }}</h5>
          <span class="muted">{{ state.subtitle | faNum }}</span>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن" (click)="hide()"></button>
      </div>
      <div class="modal-body d-flex flex-column overflow-hidden">
        <div class="table-page flex-fill h-100 w-100 mw-100 m-0 p-0" dir="rtl">
          <section class="card" app-route-analysis-table [rows]="state.rows" [columns]="state.columns" [actions]="state.actions"
            [title]="title" [subtitle]="state.subtitle" [fileName]="title + '.xlsx'" [tableKey]="modalId + '-' + state.requestKey" [extraSummary]="state.extraSummary"
            [loading]="state.loading" [hasError]="state.hasError" [errorMessage]="state.errorMessage" [hasRequestedData]="state.hasRequestedData"
            (retry)="retry.emit()" (rowAction)="rowAction.emit($event)"></section>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary rounded-pill px-4" data-bs-dismiss="modal" (click)="hide()">بستن</button>
      </div>
    </div>
  </div>
</div>
